import React from 'react';

function Legal() {
  return (
    <div>
      <h1>Legal Page</h1>
    </div>
  );
}

export default Legal;
